<template>
  <div id="loan_details">
    <group-card title="Loan Details" icon="attach_money" :tooltipText="tooltipText" class="loan_details_class">
      <div class="boxed-category">
        <div class="md-layout input-layout">
          <!-- Type -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Applicant Type"
            prefixLabel="Loan"
            v-model="application.loan.type"
            force
            :options="options.loan_application_type_options"
          >
          </validated-autocomplete-input>

          <!-- Requested Term -->
          <validated-input
            class="md-layout-item md-small-size-50 md-size-10"
            label="Term (months)"
            prefixLabel="Loan"
            v-model="application.loan.requested.term"
            type="REQUIRED_TERM"
          >
          </validated-input>

          <!-- Affordability Amount -->
          <validated-input
            type="CURRENCY"
            class="md-layout-item md-small-size-100 md-size-20"
            label="Affordability"
            prefixLabel="Loan"
            prefix="$"
            v-model="application.loan.affordability.amount"
            :suffix="
              toMonthlyAmount(
                application.loan.affordability.amount,
                application.loan.affordability.frequency,
                true
              ) + '/m'
            "
          >
          </validated-input>

          <!-- Frequency -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Frequency"
            prefixLabel="Loan"
            v-model="application.loan.affordability.frequency"
            :options="options.payment_frequency_options"
            force
          />

          <!-- Applicant Count -->
          <validated-select-input
            class="md-layout-item md-small-size-50 md-size-10"
            label="Applicants/Guarantors"
            prefixLabel="Loan"
            :value="application.applicants.length"
            @input="editApplicantCount($event)"
            required
            :options="[1, 2, 3]"
          >
          </validated-select-input>

          <!-- How did you hear about us -->
          <validated-autocomplete-input
            class="md-layout-item md-small-size-100 md-size-15"
            label="How did you hear about us?"
            prefixLabel="Loan"
            v-model="application.loan.marketing_source"
            :options="options.marketing_source_type"
            force
          />

          <!-- Genius Broker Email -->
          <validated-select-input
            class="md-layout-item md-small-size-100 md-size-20"
            label="Genius Broker"
            prefixLabel="Loan"
            v-model="application.loan.genius_broker_email"
            :options="{
            'docs@1800approved.com.au': 'David Docs',
            'docs2@1800approved.com.au': 'Docs Ausloans',
          }"
            v-if="false"
          >
          </validated-select-input>

        </div>
      </div>
      <EditLoanAsset :value="application"></EditLoanAsset>
    </group-card>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import filters from "@/components/utils/filters";
import ValidatedInputs from "@/components/ValidatedInput";
import GroupCard from "@/components/Cards/GroupCard";
import GroupCardRow from "@/components/Cards/GroupCardRow";
import Editors from '@/components/Editors';
import { newApplicant } from "@/schema.js";
import EditLoanComments from "./EditLoanComments";
import EditLoanAsset from "./EditLoanAsset";
export default {
  components: {
    EditLoanComments,
    ...ValidatedInputs,
    GroupCard,
    GroupCardRow,
    ...Editors,
    EditLoanAsset,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
  },
  watch: {
  },
  computed: {
    // standard list of options from store
    ...mapGetters({
      options: "options",
    }),

    // internal reference to the v-model on this component, handles incomeing and outgoing changes
    application: {
      get() {
        return this.value;
      },
      set(application) {
        this.$emit("input", application);
      },
    },
  },
  methods: {
    // make all filters available as methods
    ...filters,

    editApplicantCount(count) {
      let current_count = this.application.applicants.length;
      let difference = count - current_count;

      if (difference > 0) {
        for (let i = 0; i < difference; i++) {
          let new_applicant = newApplicant();
          new_applicant.type = "Secondary Borrower";
          this.application.applicants.push(new_applicant);
        }
      } else if (difference < 0) {
        for (let i = 0; i < -difference; i++) {
          this.application.applicants.pop();
        }
      }

      // if the count = current count, now action required
    }
  },
  data() {
    return{
      tooltipText: '<li>Consumer - PAYG - Full Time, Part-Time or Casual</li>'+
                    '<li>Sole Trader - individual under ABN</li>'+
                    '<li>Company - ABN - Has employees see below for company loans process</li>'+
                    '<li>Trust - Part of a beneficiary</li>'+
                    '<li>Partnership - Multiple people under the one ABN</li>'+
                    '<p>If loan is for business purpose - select which best reflects the applicant type:</p>'+
                    '<li>If self-employed (sole trader) - Select Sole Trader</li>'+
                    '<li>If owner/director of a company - select which best reflects the type of company (partnership, trust, private company etc - this will show in ABN lookup)</li>',
    }
  },
  filters: {
    // make all filters available as filters
    ...filters,
  },
  async beforeCreate() {
    const params = {
      types: [
        'loan_application_type_options',
        'payment_frequency_options',
        'marketing_source_type',
      ],
    }
    await this.$store.dispatch('fetch_types', { params });
  },
};
</script>
